export default __webpack_public_path__ + "static/zaru_collages_v6-1-7046d0152faf76b255824bbde073d3c0.png";